import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';


const AccountsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/accounts" */
    'routes/Control/Accounts/AccountsRoute'
  )
));

const AccountDetailsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/account-details" */
    'routes/Control/Accounts/DetailsRoute'
  )
));

const AccountCreditRecordsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/account-credit-records" */
    'routes/Control/Accounts/CreditRecordsRoute'
  )
));

const AddAccountCreditsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/add-account-credit" */
    'routes/Control/Accounts/AddCreditsRoute'
  )
));

const getControlAccountsRoutes = () => {
  return [
    {path: paths.getPathControlAccounts(), component: AccountsRoute},
    {path: paths.getPathControlAccountDetails(":accountId"), component: AccountDetailsRoute},
    {path: paths.getPathControlAccountCreditRecords(":accountId"), component: AccountCreditRecordsRoute},
    {path: paths.getPathControlAddAccountCredits(":accountId"), component: AddAccountCreditsRoute},
  ]
}



export { getControlAccountsRoutes };
